import { render, staticRenderFns } from "./Patient.vue?vue&type=template&id=d6a8f320&"
import script from "./Patient.vue?vue&type=script&lang=ts&"
export * from "./Patient.vue?vue&type=script&lang=ts&"
import style0 from "./Patient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports